export const PARENT_CATEGORY_A11Y_TEXT = 'a11y.parentcategorytext';
export const CHILD_CATEGORY_A11Y_TEXT = 'a11y.childcategorytext';

export const DEFAULT_ITEMS_TO_LIST = 10;
